export default {
  marginBottom: `2.8125rem`,
};
